import { render } from "./AffiliateInfoModal.vue?vue&type=template&id=36b0dcdb&scoped=true"
import script from "./AffiliateInfoModal.vue?vue&type=script&lang=js"
export * from "./AffiliateInfoModal.vue?vue&type=script&lang=js"

import "./AffiliateInfoModal.vue?vue&type=style&index=0&id=36b0dcdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0dcdb"]])

export default __exports__